/** @format */

import React, { Component } from 'react';
import ClientTableOverview from '../../Clients/ClientTableOverview/ClientTableOverview';
import SaleTable from '../SaleTable/SaleTable';
import SaleShippingForm from './SaleShippingForm/SaleShippingForm';
import SaleShippingType from './SaleShippingType/SaleShippingType';
import { Modal, Form, Icon, Header, Divider } from 'semantic-ui-react';

import { inject, observer } from 'mobx-react';

@inject('SalesStore', 'RequestsStore')
@observer
class SalesForm extends Component {
  renderContent = content => {
    if (content !== undefined && content !== null && content !== '') {
      return content;
    } else {
      return '-';
    }
  };

  render() {
    const { SalesStore, RequestsStore } = this.props;
    return (
      <Modal
        onClose={() => {
          SalesStore.closeSaleForm();
          SalesStore.resetCurrentSale();
        }}
        open={SalesStore.salesParams.editSaleForm.open}
      >
        <Modal.Content>
          <Header className="modal-header" as="h3">
            <small>
              <Icon name="dollar sign" />
            </small>
            Concludi Vendita
          </Header>
          <div className="header-spacer"></div>
          <ClientTableOverview
            renderContent={content => this.renderContent(content)}
          />
          <SaleShippingForm />
          <SaleShippingType />
          <SaleTable />
          <Divider />
          <Form.Button
            className={
              !SalesStore.currentSale.data.shippingType ? 'disable' : null
            }
            onClick={() => {
              SalesStore.closeSaleForm();
              SalesStore.handleSaleFormSubmit();
              RequestsStore.resetHasBeenChanged();
            }}
            color="green"
            fluid
            size="small"
          >
            <Icon name="dollar sign" /> Concludi Vendita
          </Form.Button>
          <div
            className="close-button"
            onClick={() => {
              SalesStore.closeSaleForm();
              SalesStore.resetCurrentSale();
            }}
          >
            X
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default SalesForm;
